import React from "react";

function Hero() {
  return (
    <section className="container-fluid" id="supportHero">

      {/* Top Bar */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center py-3 px-3 px-md-5 text-center text-md-start">
        <h4 className="mb-2 mb-md-0">Support Portal</h4>

        <a href="#" className="text-white text-decoration-none">
          Track Ticket
        </a>
      </div>

      {/* Main Section */}
      <div className="row px-3 px-md-5 py-4">

        {/* Left Section */}
        <div className="col-12 col-md-6 mb-4 mb-md-0">

          <h1 className="fs-4">
            Search for an answer or browse help topics to create a ticket
          </h1>

          <input
            type="text"
            className="form-control mt-3"
            placeholder="Eg. how do I activate my account"
          />

          <div className="mt-3" style={{ lineHeight: "2" }}>
            <a href="#" className="d-block text-white text-decoration-none">
              Track Account Opening
            </a>
            <a href="#" className="d-block text-white text-decoration-none">
              Track segment activation
            </a>
            <a href="#" className="d-block text-white text-decoration-none">
              Intraday Margins
            </a>
            <a href="#" className="d-block text-white text-decoration-none">
              Kite User Manual
            </a>
          </div>

        </div>

        {/* Right Section */}
        <div className="col-12 col-md-6">

          <h1 className="fs-4">Featured</h1>

          <ol className="mt-3" style={{ lineHeight: "1.8" }}>
            <li>
              <a href="#" className="text-white text-decoration-none">
                Current Takeovers and Delisting - January 2026
              </a>
            </li>
            <li>
              <a href="#" className="text-white text-decoration-none">
                Latest Intraday leverages - MIS & CO
              </a>
            </li>
          </ol>

        </div>

      </div>

    </section>
  );
}

export default Hero;